import { Field, TextInput, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

export default function EditStats({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const add = () => set("items", [...(value.items || []), { value: "+100", label: "Novo número" }]);
  const remove = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Estatísticas">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="stats-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="stats-title-input" /></Field>
        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Números</span>
            <ListAddBtn onClick={add} label="Adicionar" testId="stats-add" />
          </div>
          <div className="space-y-3">
            {(value.items || []).map((s, i) => (
              <div key={i} data-testid={`stats-row-${i}`} className="grid sm:grid-cols-12 gap-3 items-center border border-border p-3">
                <div className="sm:col-span-3"><Field label="Valor"><TextInput value={s.value} onChange={(v) => setItem(i, "value", v)} testId={`stats-value-${i}`} /></Field></div>
                <div className="sm:col-span-8"><Field label="Rótulo"><TextInput value={s.label} onChange={(v) => setItem(i, "label", v)} testId={`stats-label-${i}`} /></Field></div>
                <div className="sm:col-span-1 flex justify-end pt-6"><ListRemoveBtn onClick={() => remove(i)} testId={`stats-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
